import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface Directory extends AttributesMixin<typeof Directory> { }

@define
export class Directory extends Model {

  static attributes = {
    name: String,
    dirPath: String,
    isAlreadyInUse: Boolean,
    nestedNodes: [Directory]
  }
}

export interface Directories extends AttributesMixin<typeof Directories> { }

@define
export class Directories extends Model {
  static endpoint = restfulIO('api/v1/ingest/connections/directories');

  static attributes = {
    list: [Directory]
  }

  async getDirectoriesList(params) {
    const url = (this.getEndpoint() as any).getUrl(this);

    const response = await fetch(url, {
      method: 'POST',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'X-Platform-Code': getPlatformCode()
      }),

      body: this.buildRemoteServerDetailsFormData(params)
    });

    if (response.status < 200 || response.status >= 300) {
      let error = response.statusText || `HTTP Error ${response.status}`;
      await response.json()
        .then(e => error = Object.keys(e.errors).map(k => e.errors[k].join(' ')).join(' '))
        .catch(e => console.error('Cannot parse response data'));
      throw new Error(error);
    }

    const json = await response.json();
    this.set(json);
    return this;
  }

  buildRemoteServerDetailsFormData(params) {
    const formData = new FormData();
    formData.append('host', this.defaultValue(params.host));
    formData.append('port', this.defaultValue(params.port));
    formData.append('userName', this.defaultValue(params.userName));
    formData.append('password', this.defaultValue(params.password));
    formData.append('customerCompanyId', this.defaultValue(params.customerCompanyId));
    formData.append('encryptionMethodId', this.defaultValue(params.encryptionMethodId));

    if (params.file) {
      formData.append("file", params.file, params.file.name);
    }

    if (params.connectionId) {
      formData.append("connectionId", this.defaultValue(params.connectionId));
    }

    return formData;
  }

  defaultValue(value: any) {
    return Boolean(value) ? value.toString() : '';
  }
}
